export const config = require('./config.json');
